import {
  Dialog,
  DialogActions,
  Button,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@eye-able/ui';
import type { ReactNode } from 'react';
import LoadingButton from '@components/Button/LoadingButton';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  confirmText: ReactNode;
  confirmIcon?: ReactNode;
  loading?: boolean;
  onConfirm: () => void;
}

const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  confirmText,
  confirmIcon,
  loading = false,
  onConfirm,
}: ConfirmDialogProps) => {
  const { t } = useInlineTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent maxWidth='md'>
        <DialogTitle>{title}</DialogTitle>
        {description ? (
          <DialogDescription>{description}</DialogDescription>
        ) : null}
        {children}
        <DialogActions>
          <DialogClose asChild>
            <Button type='button' variant='outline'>
              {t('cancel')}
            </Button>
          </DialogClose>
          <LoadingButton
            type='button'
            variant='yellow'
            loading={loading}
            onClick={onConfirm}
          >
            {confirmIcon}
            {confirmText}
          </LoadingButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
